module.exports = __webpack_public_path__ + "static/media/close.aa4fde2e.svg";